import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { createSx } from '@ui-lib/utils';
import { Header } from '../../../../../components/Header';
import qrWarning from '../../../../../assets/qr-warning.svg';

const sx = createSx({
  root: {
    height: '100%',
  },
  container: {
    width: '100%',
    height: '100%',
    p: 2,
    boxSizing: 'border-box',
  }
});

export const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <Stack sx={sx.root}>
      <Header />
      <Stack
        sx={sx.container}
        alignItems='center'
        justifyContent='center'
        spacing={2}
      >
        <img src={qrWarning} />
        <Typography variant='subtitle1Bold' textAlign='center'>
          {t('emptyBol')}
        </Typography>
      </Stack>
    </Stack>

  );
};
